// Tabs Pannel
// Matt
// Chris
// class TabsAutomatic {
// 	constructor(groupNode) {
// 	  this.tablistNode = groupNode;

// 	  this.tabs = [];

// 	  this.firstTab = null;
// 	  this.lastTab = null;

// 	  this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
// 	  this.tabpanels = [];

// 	  for (var i = 0; i < this.tabs.length; i += 1) {
// 		var tab = this.tabs[i];
// 		var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

// 		tab.tabIndex = -1;
// 		tab.setAttribute('aria-selected', 'false');
// 		this.tabpanels.push(tabpanel);

// 		tab.addEventListener('keydown', this.onKeydown.bind(this));
// 		tab.addEventListener('click', this.onClick.bind(this));

// 		if (!this.firstTab) {
// 		  this.firstTab = tab;
// 		}
// 		this.lastTab = tab;
// 	  }

// 	  this.setSelectedTab(this.firstTab, false);
// 	}

// 	setSelectedTab(currentTab, setFocus) {
// 	  if (typeof setFocus !== 'boolean') {
// 		setFocus = true;
// 	  }
// 	  for (var i = 0; i < this.tabs.length; i += 1) {
// 		var tab = this.tabs[i];
// 		if (currentTab === tab) {
// 		  tab.setAttribute('aria-selected', 'true');
// 		  tab.removeAttribute('tabindex');
// 		  this.tabpanels[i].classList.remove('is-hidden');
// 		  if (setFocus) {
// 			tab.focus();
// 		  }
// 		} else {
// 		  tab.setAttribute('aria-selected', 'false');
// 		  tab.tabIndex = -1;
// 		  this.tabpanels[i].classList.add('is-hidden');
// 		}
// 	  }
// 	}

// 	setSelectedToPreviousTab(currentTab) {
// 	  var index;

// 	  if (currentTab === this.firstTab) {
// 		this.setSelectedTab(this.lastTab);
// 	  } else {
// 		index = this.tabs.indexOf(currentTab);
// 		this.setSelectedTab(this.tabs[index - 1]);
// 	  }
// 	}

// 	setSelectedToNextTab(currentTab) {
// 	  var index;

// 	  if (currentTab === this.lastTab) {
// 		this.setSelectedTab(this.firstTab);
// 	  } else {
// 		index = this.tabs.indexOf(currentTab);
// 		this.setSelectedTab(this.tabs[index + 1]);
// 	  }
// 	}

// 	/* EVENT HANDLERS */

// 	onKeydown(event) {
// 	  var tgt = event.currentTarget,
// 		flag = false;

// 	  switch (event.key) {
// 		case 'ArrowLeft':
// 		  this.setSelectedToPreviousTab(tgt);
// 		  flag = true;
// 		  break;

// 		case 'ArrowRight':
// 		  this.setSelectedToNextTab(tgt);
// 		  flag = true;
// 		  break;

// 		case 'Home':
// 		  this.setSelectedTab(this.firstTab);
// 		  flag = true;
// 		  break;

// 		case 'End':
// 		  this.setSelectedTab(this.lastTab);
// 		  flag = true;
// 		  break;

// 		default:
// 		  break;
// 	  }

// 	  if (flag) {
// 		event.stopPropagation();
// 		event.preventDefault();
// 	  }
// 	}

// 	onClick(event) {
// 	  this.setSelectedTab(event.currentTarget);
// 	}
//   }


jQuery(document).ready(function($) {

//   $('.accordion button').click(function() {
//     	$(this).parent().toggleClass('active');
//     	$(this).next().slideToggle();
//   });

    // $('.my-nav-toggle').click(function(){
    //     $('.my-main-menu').toggleClass('active');
    //     $('body').toggleClass('coverlayed');
    //     return false;
    // });

    // $('.my-main-menu .close').click(function(){
    //     $('.my-main-menu').toggleClass('active');
    //     $('body').toggleClass('coverlayed');
    //     return false;
    // });


    // $('.drop-products').click(function(){
    //     if($('.my-top-header').is(":visible")) {
    //         $('.product-dropdown__shop').toggleClass('active');
    //         $('body').toggleClass('nav-active');
    //         return false;
    //     }
    // });

    // $('.drop-experience').click(function(){
    //     if($('.my-top-header').is(":visible")) {
    //         $('.product-dropdown__experience').toggleClass('active');
    //         $('body').toggleClass('nav-active');
    //         return false;
    //     }
    // });

    // $('.drop-about').click(function(){
    //     if($('.my-top-header').is(":visible")) {
    //         $('.product-dropdown__about').toggleClass('active');
    //         $('body').toggleClass('nav-active');
    //         return false;
    //     }
    // });


	// document.addEventListener('mouseup', function (event) {
    //   	// Shop Menu
	// 	if(event.target.closest('.product-dropdown__shop')) {
    //       	closeExperienceDropdown();
    //       	closeAboutDropdown();
	// 	} else {
    //       if(event.target.closest('.drop-shop')) {
    //         closeExperienceDropdown();
    //         closeAboutDropdown();
    //       } else {
    //         closeShopDropdown();
    //       }
	// 	}

	//     // Experience Menu
	// 	if(event.target.closest('.product-dropdown__experience')) {
    //       	closeShopDropdown();
	// 		closeAboutDropdown();
	// 	} else {
    //       if(event.target.closest('.drop-experience')) {
    //         closeShopDropdown();
    //         closeAboutDropdown();
    //       } else {
    //         closeExperienceDropdown();
    //       }
	// 	}

	//     // About Menu
	// 	if(event.target.closest('.product-dropdown__about')) {
    //       	closeShopDropdown();
    //       	closeExperienceDropdown();
	// 	} else {
    //       if(event.target.closest('.drop-about')) {
    //         closeExperienceDropdown();
    //         closeShopDropdown();
    //       } else {
    //         closeAboutDropdown();
    //       }
	// 	}
	// });


//   function closeExperienceDropdown() {
//         if($('.my-top-header').is(":visible")) {
//             $('.product-dropdown__experience').removeClass('active');
//             $('body').removeClass('nav-active');
//             return false;
//         }
//   }

//   function closeShopDropdown() {
//         if($('.my-top-header').is(":visible")) {
//             $('.product-dropdown__shop').removeClass('active');
//             $('body').removeClass('nav-active');
//             return false;
//         }
//   }

//   function closeAboutDropdown() {
//         if($('.my-top-header').is(":visible")) {
//             $('.product-dropdown__about').removeClass('active');
//             $('body').removeClass('nav-active');
//             return false;
//         }
//   }


    // $('.drop-close').click(function(){
    //     $('.product-dropdown__shop').toggleClass('active');
    //     $('body').toggleClass('nav-active');
    //     return false;
    // });

    $('.faq-content h2').nextUntil('h2, hr').hide();
    $('.faq-content h2').click(function(){
        $(this).toggleClass('open');
        $(this).nextUntil('h2, hr').slideToggle();
    });


    function faqmagic() {
        if(window.location.hash) {
            var hash = window.location.hash;
            console.log("this is my hash " + hash + " ainit kewl?");
            $('.faq-content h2').removeClass('open').nextUntil('h2').hide();
            $(hash).addClass('open');
            var hht = $('#shopify-section-header').height();
            $('html, body').animate({
                scrollTop: $(hash).offset().top - hht
            }, 300, function(){
                $(hash).nextUntil('h2').show();

            });
        } else {
            $('.faq-content h2').nextUntil('h2').hide();
        }
    }

    //because apparenlty pages aren't as cool as lame anchors
    $(window).bind('hashchange', function () {
        console.log('HASH CHANGED');
        faqmagic();
    });
    faqmagic();


    function openGuide(){
        $( '#coverContent' ).load( '/pages/buying-guide div#buyersGuide' );
        $('.coverlay').addClass('active');
        $('body').addClass('coverlayed');
    }

    $('.coverlay .close').click(function() {
        $('.coverlay').removeClass('active');
        $('body').removeClass('coverlayed');
    });

    $('a[href="/pages/buying-guide"]').click(function() {
        openGuide();
        return false;
    });

});



